import React from 'react';
import { Form } from '@dashboard/components/Formik';
import usePage from '@dashboard/hooks/usePage';

const SlugForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Form
      initialValues={{
        slug: page.slug,
      }}
      fields={[
        {
          name: 'slug',
          id: 'slug',
          type: 'text',
          label: 'URL slug',
          placeholder: 'your-page-slug',
          required: true,
          helpText: 'If you change this, any links using the old URL will stop working.',
        },
      ]}
      onSubmit={async (values, actions) => {
        const { data, error } = await updatePage.mutateAsync(values);

        if (data) {
          actions.resetForm({
            values: {
              slug: data.slug,
            },
          });
        }

        return {
          data,
          error,
        };
      }}
    />
  );
};

export default SlugForm;
